export default __webpack_public_path__ + "static/media/male.ca285fde.png";